import { FriendsO, HomeO, PhoneO } from '@react-vant/icons';
import { Helmet, useModel } from '@umijs/max';
import { Button, Card, Dialog, Image, Toast } from 'react-vant';
import styles from './index.less';
import { useEffect, useState } from 'react';
import { getWechatFloorButler } from '@/service/banner';

const Bult = () => {

  const { defaultRoom } = useModel(
    'useDefaultRoom',
    (model) => ({
      defaultRoom: model.defaultRoom,
    }),
  );
  // console.log('defaultRoom', defaultRoom)
  const [WechatFloorButlerData, setWechatFloorButlerData] = useState({
    name: '',
    phone: '',
    floorName: '',
    avatar: ''
  });
  useEffect(() => {
    getWechatFloorButler({ pageNum: 1, pageSize: 10, communityId: defaultRoom?.communityId, flooId: defaultRoom?.floorId }).then(
      (res) => {
        if (res && res.code === 200) {
          if (res?.rows?.length) {
            setWechatFloorButlerData(res.rows[0]);
          }
        }
      },
    );
  }, []);
  const callPhone = () => {
    // window.location.href = 'tel://1888911946'
    // window.open = 'tel://188****946'
    if (!WechatFloorButlerData?.phone) {
      Toast('电话信息为空！')
      return
    }
    Dialog.confirm({
      title: '',
      message: `${WechatFloorButlerData?.phone}`,
      confirmButtonText: '拨打',
      onCancel: () => console.log('cancel'),
      onConfirm: () => {
        window.location.href = `tel://${WechatFloorButlerData?.phone}`;
      },
    });
  };

  return (
    <div className={styles.bultDetail}>
      <Helmet>
        <title>管家信息</title>
      </Helmet>
      <div className={styles.container}>
        <Card round>
          <Card.Body>
            <div className={styles.imges}>
              {' '}
              <Image width="100px" height="100" src={WechatFloorButlerData.avatar} />
            </div>
            <div className={styles.info}>
              <div className={styles.title}>专属管家</div>
              <div className={styles.name}>
                <div className={styles.name}>
                  <FriendsO />
                  姓名：
                </div>{' '}
                {WechatFloorButlerData?.name || '-'}
              </div>
              <div className={styles.phone}>
                <div className={styles.name}>
                  <PhoneO />
                  电话：
                </div>{' '}
                {WechatFloorButlerData?.phone || '-'}
              </div>
              <div className={styles.phone}>
                <div className={styles.name}>
                  {' '}
                  <HomeO />
                  服务楼栋：
                </div>{' '}
                {WechatFloorButlerData?.floorName || '-'}
              </div>
            </div>
          </Card.Body>
        </Card>

        <div className={styles['demo-button']}>
          <Button type="primary" onClick={callPhone} block round>
            联系管家
            {/* <a href="tel:13556891235">联系管家</a> */}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Bult;
